var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBootcampjsdays(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_1647)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_158_1647)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 5.47833C8.07323 5.63268 7.11836 5.93071 6.32634 6.50614C5.79575 6.89164 5.32914 7.35825 4.94364 7.88884C3.75 9.53175 3.75 11.8753 3.75 16.5625C3.75 21.2497 3.75 23.5933 4.94364 25.2362C5.32914 25.7668 5.79575 26.2334 6.32634 26.6189C7.96925 27.8125 10.3128 27.8125 15 27.8125C16.0487 27.8125 16.98 27.8125 17.8125 27.7991L17.8125 27.7115C17.8124 26.6465 17.8124 25.9977 17.901 25.4381C18.3881 22.3627 20.8001 19.9506 23.8756 19.4635C24.4352 19.3749 25.084 19.3749 26.149 19.375L26.2366 19.375C26.25 18.5427 26.25 17.6115 26.25 16.5631C26.25 11.8759 26.25 9.53175 25.0564 7.88884C24.6709 7.35825 24.2043 6.89164 23.6737 6.50614C22.8816 5.93071 21.9268 5.63268 20.625 5.47833V6.5625C20.625 7.59803 19.7855 8.4375 18.75 8.4375C17.7145 8.4375 16.875 7.59803 16.875 6.5625V5.31601C16.2949 5.3125 15.6715 5.3125 15 5.3125C14.3285 5.3125 13.7051 5.3125 13.125 5.31601V6.5625C13.125 7.59803 12.2855 8.4375 11.25 8.4375C10.2145 8.4375 9.375 7.59803 9.375 6.5625V5.47833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1683 21.25C25.0304 21.2502 24.5544 21.2544 24.1689 21.3154C21.8958 21.6754 20.1129 23.4583 19.7529 25.7314C19.6919 26.1169 19.6877 26.5929 19.6875 27.7308C21.487 27.6128 22.7027 27.3243 23.6737 26.6189C24.2043 26.2334 24.6709 25.7668 25.0564 25.2362C25.7618 24.2652 26.0503 23.0495 26.1683 21.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 2.8125C12.1875 2.29473 11.7678 1.875 11.25 1.875C10.7322 1.875 10.3125 2.29473 10.3125 2.8125V6.5625C10.3125 7.08027 10.7322 7.5 11.25 7.5C11.7678 7.5 12.1875 7.08027 12.1875 6.5625V2.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 2.8125C19.6875 2.29473 19.2678 1.875 18.75 1.875C18.2322 1.875 17.8125 2.29473 17.8125 2.8125V6.5625C17.8125 7.08027 18.2322 7.5 18.75 7.5C19.2678 7.5 19.6875 7.08027 19.6875 6.5625V2.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8125 4.92295L9.31613 4.9818C7.96966 5.14146 6.92034 5.45654 6.03245 6.10164C5.45941 6.51797 4.95547 7.02191 4.53913 7.59495C3.87007 8.51585 3.55593 9.61052 3.40211 11.0302C3.24999 12.4343 3.25 14.2141 3.25 16.5314V16.5625V16.5936C3.25 18.9109 3.24999 20.6907 3.40211 22.0948C3.55593 23.5145 3.87007 24.6092 4.53914 25.5301C4.95547 26.1031 5.45941 26.607 6.03245 27.0234C6.95334 27.6924 8.04802 28.0066 9.46772 28.1604C10.8718 28.3125 12.6516 28.3125 14.9688 28.3125H15H15.0022C16.0489 28.3125 16.9838 28.3125 17.8205 28.2991L18.3125 28.2912L18.3125 27.7991L18.3125 27.7115C18.3124 26.6305 18.3138 26.028 18.3948 25.5163C18.8481 22.6548 21.0923 20.4106 23.9538 19.9573C24.4655 19.8763 25.068 19.8749 26.1489 19.875L26.2366 19.875L26.7287 19.875L26.7366 19.383C26.75 18.5467 26.75 17.6123 26.75 16.5662V16.5631V16.5319C26.75 14.2147 26.75 12.4347 26.5979 11.0305C26.4441 9.61069 26.1299 8.51586 25.4609 7.59495C25.0445 7.02191 24.5406 6.51797 23.9675 6.10164C23.0797 5.45654 22.0303 5.14146 20.6839 4.9818L20.1875 4.92295V2.8125C20.1875 2.01859 19.5439 1.375 18.75 1.375C17.9561 1.375 17.3125 2.01859 17.3125 2.8125V4.81865L16.878 4.81602C16.2964 4.8125 15.6718 4.8125 15.0011 4.8125H15H14.9989C14.3282 4.8125 13.7036 4.8125 13.122 4.81602L12.6875 4.81865V2.8125C12.6875 2.01859 12.0439 1.375 11.25 1.375C10.4561 1.375 9.8125 2.01859 9.8125 2.8125V4.92295ZM26.6673 21.2827L26.7022 20.7499L26.1683 20.75C25.0488 20.7502 24.5247 20.7528 24.0907 20.8216C21.6036 21.2155 19.653 23.1661 19.2591 25.6532C19.1903 26.0872 19.1877 26.6113 19.1875 27.7308L19.1874 28.2647L19.7202 28.2298C21.5475 28.1099 22.88 27.8135 23.9675 27.0234C24.5406 26.607 25.0445 26.1031 25.4609 25.5301C26.251 24.4425 26.5474 23.11 26.6673 21.2827Z",
    stroke: "url(#paint0_linear_158_1647)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_158_1647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.8125C9.44036 12.8125 10 12.2529 10 11.5625C10 10.8721 9.44036 10.3125 8.75 10.3125C8.05964 10.3125 7.5 10.8721 7.5 11.5625C7.5 12.2529 8.05964 12.8125 8.75 12.8125Z",
    fill: "#062A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16.5625C10 17.2529 9.44036 17.8125 8.75 17.8125C8.05964 17.8125 7.5 17.2529 7.5 16.5625C7.5 15.8721 8.05964 15.3125 8.75 15.3125C9.44036 15.3125 10 15.8721 10 16.5625Z",
    fill: "#062A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12.8125C15.6904 12.8125 16.25 12.2529 16.25 11.5625C16.25 10.8721 15.6904 10.3125 15 10.3125C14.3096 10.3125 13.75 10.8721 13.75 11.5625C13.75 12.2529 14.3096 12.8125 15 12.8125Z",
    fill: "#062A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16.5625C16.25 17.2529 15.6904 17.8125 15 17.8125C14.3096 17.8125 13.75 17.2529 13.75 16.5625C13.75 15.8721 14.3096 15.3125 15 15.3125C15.6904 15.3125 16.25 15.8721 16.25 16.5625Z",
    fill: "#062A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 22.8125C15.6904 22.8125 16.25 22.2529 16.25 21.5625C16.25 20.8721 15.6904 20.3125 15 20.3125C14.3096 20.3125 13.75 20.8721 13.75 21.5625C13.75 22.2529 14.3096 22.8125 15 22.8125Z",
    fill: "#062A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.5625C22.5 12.2529 21.9404 12.8125 21.25 12.8125C20.5596 12.8125 20 12.2529 20 11.5625C20 10.8721 20.5596 10.3125 21.25 10.3125C21.9404 10.3125 22.5 10.8721 22.5 11.5625Z",
    fill: "#062A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 17.8125C21.9404 17.8125 22.5 17.2529 22.5 16.5625C22.5 15.8721 21.9404 15.3125 21.25 15.3125C20.5596 15.3125 20 15.8721 20 16.5625C20 17.2529 20.5596 17.8125 21.25 17.8125Z",
    fill: "#062A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21.5625C10 22.2529 9.44036 22.8125 8.75 22.8125C8.05964 22.8125 7.5 22.2529 7.5 21.5625C7.5 20.8721 8.05964 20.3125 8.75 20.3125C9.44036 20.3125 10 20.8721 10 21.5625Z",
    fill: "#062A6A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_158_1647",
    x: -21.25,
    y: -23.125,
    width: 72.5,
    height: 75.9375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_158_1647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_158_1647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_158_1647",
    x: 4.5,
    y: 7.3125,
    width: 31,
    height: 28.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_1647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_158_1647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_158_1647",
    x1: 3.75,
    y1: 1.875,
    x2: 29.4369,
    y2: 24.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_1647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootcampjsdays);
export default __webpack_public_path__ + "static/media/Bootcamp js days.9928718f1e5e4165a005efb8760b8cc6.svg";
export { ForwardRef as ReactComponent };